import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import BookingAllViewsV1 from './booking-all-views-v1';
import BookingAllViewsV2 from '../../../views/bookings-v2/components/BookingViews/BookingAllViews';

const BookingAllViews = () => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <BookingAllViewsV2 />;
  }

  return <BookingAllViewsV1 />;
};

export default BookingAllViews;
